$(document).ready(function () {
    $(".select-form option").each(function() {
        if ($(this).is(":selected")) {
            $(".form-collapse").hide();
            $("#" + $(this).attr("data-collapse")).show()
        }
    })
    $(".select-form").on("change", function() {
        $(".form-collapse").hide();
        $("#" + $(this).find("option:selected").attr("data-collapse")).show()
    })
});
